var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Accordion',{attrs:{"show":this.accordionShow,"title":_vm.guestName,"lightTheme":true,"largeSvg":true,"blueTheme":!_vm.hideCreate},on:{"toggle":() => {
				this.accordionShow = !this.accordionShow
			}}},[_c('div',[_c('Guest_Form',{attrs:{"guestlid":_vm.guestlid,"edit":_vm.hideCreate},on:{"hide-accordion":_vm.emptyCreate}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }